'use client';

import { Suspense } from 'react';
import { BuyerOrdersPage } from '@/platform/commerce';
import { MarketplacePageFrame } from '../MarketplacePageFrame';

export function MarketplaceOrdersPage() {
  return (
    <MarketplacePageFrame title="Your orders" description="Marketplace purchase history.">
      <Suspense fallback={<p className="text-muted">Loading orders…</p>}>
        <BuyerOrdersPage />
      </Suspense>
    </MarketplacePageFrame>
  );
}
